import type { ClientState } from '../types/state';

/**
 * Factory function to create a new client state object.
 *
 * This creates the initial state for an axios client instance,
 * managing token refresh, request queuing, and retry state.
 *
 * @returns A new ClientState object with empty/default values
 */
export function createClientState(): ClientState {
  return {
    refreshPromise: null,
    requestQueue: [],
    failedRequestsQueue: [],
    coldStartDialogShown: false,
    coldStartDialogShownAt: null,
  };
}
